<sdps-modal-beta sdps-title="Tax Withholding Calculator" class="sdps-headline strong" id="{{modalId}}">
    <div slot="modal-body">
        <form>
            <fieldset>
                <div class="input-container">
                    <div class="label-text">Enter an amount</div>
                    <div class="wrap-dollar-sign-amountinput">
                        <span class="dollar-sign">$</span>
                        <input class="amount-input" size="medium" type="text" 
                            (paste)="onPaste($event)"
                            (keydown)="validationService.validateNumberInput($event, percentAllowedChars)"
                            maxlength="10" show-addon addon-type="text" sr-input-label="dollars" [formControl]="amountControl"
                            id="amount-input" #amountinput name="amountinput" />
                    </div>
                    <div class="calculated-values-container">
                        <div class="spaced-calculated-value">
                            <div class="calculated-value">Percent equivalent:</div>
                            <div [ngClass]="amountControl.value ? 'standard-calculated-value-color' : 'grey-calculated-value-color'"  data-testid="calculated-tax-percent">
                                {{calculatedTaxPercent.value}}%
                            </div>
                        </div>
                        <div class="spaced-calculated-value">
                            <div class="calculated-value">Actual amount:</div>
                            <div [ngClass]="amountControl.value ? 'standard-calculated-value-color' : 'grey-calculated-value-color'"   data-testid="actual-amount">
                                ${{actualAmount}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="federal-tax-prompt" *ngIf="showFedTaxPrompt">{{fedTaxPrompt}}</div>
                <div class="net-amount-type-warning" *ngIf="isNet" data-testid="net-warning">
                    <sdps-icon id="net-warning-icon" color="warning" type="functional" name="warning" size="small"></sdps-icon>
                    <span>{{netAmountTypeWarning}}</span>
                </div>
                <div class="has-tax-error" *ngIf=" calculatedTaxPercent?.invalid" data-testid="has-tax-error">{{TaxError}}</div>
                <sdps-button variation="primary" fluid sdps-id="primary-fluid" size="small" (click)="onApplyWithholdingClick()"
                    type="submit">Apply this withholding</sdps-button>
            </fieldset>
        </form>
    </div>
</sdps-modal-beta>